import type {
  AdjacencyMapSetting,
  GroupAssetMapSetting,
  HeaderLabelSetting,
  HighestRiskTableSetting,
  RiskMetricsGraphSetting,
  RiskRatingsGraphSetting,
  RiskSurfaceAreaGraphSetting,
  SingleAssetMapSetting,
  AggregateStatisticsSetting,
  BaseDataGridSettingInput,
  PortfolioMapSetting,
} from "@/apis/services/OrganizationService";

export type SettingsParams =
  | SingleAssetMapSetting
  | GroupAssetMapSetting
  | PortfolioMapSetting
  | AdjacencyMapSetting
  | RiskRatingsGraphSetting
  | RiskMetricsGraphSetting
  | HighestRiskTableSetting
  | AggregateStatisticsSetting
  | HeaderLabelSetting
  | RiskSurfaceAreaGraphSetting
  | BaseDataGridSettingInput;

export const DEFAULT_DATAGRID_COLUMN = {
  value: null,
  field_type: "SINGLESELECT",
  description: null,
  options: [],
  visible: true,
  disabled: false,
  help_text: null,
  required: false,
  visibility_condition: null,
  validation: null,
  default_value: null,
  default_value_rules: null,
  read_only: false,
};

export const DEFAULT_DATAGRID_FILTER = {
  description: null,
  options: [],
  visible: true,
  disabled: false,
  help_text: null,
  required: false,
  visibility_condition: null,
  validation: null,
  default_value: ["DOWNTIME", "ECONOMIC_LOSS"],
  default_value_rules: null,
  read_only: false,
};

export const AREA_DISPLAY_LABEL = "sq ft";
export const LENGTH_DISPLAY_LABEL = "ft";
